<div class="modal-header bg-blu txt-white">
  Report Stazioni BTS
  <button
    type="button"
    class="close text-white"
    aria-label="Close"
    (click)="activeModal.close()"
  >
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body p-0 custom-modal-body">
  <div class="container-fluid">
    <div class="row">
      <div class="col p-3 modal-cont">
        <ul class="list-group list-none">
          <li class="py-1">
            <span class="li-item-header">Nome: </span> {{ name ? name : "-" }}
          </li>

          <li *ngFor="let item of data | keyvalue" class="py-1">
            <div
              *ngIf="
                DATES.includes(item.key);
                then thenBlock;
                else elseBlock
              "
            ></div>

            <ng-template #thenBlock> 
              <span class="li-item-header">{{ STAZIONI_BTS_MAPPING[item.key] }}:</span>
              {{ item.value && item.value.toString().trim()
                  ? (item.value.toString().trim() | date: 'dd/MM/yyyy') || "-"
                  : "-"
              }}
            </ng-template>

            <ng-template #elseBlock>
              <span class="li-item-header"
                >{{ STAZIONI_BTS_MAPPING[item.key] }}:</span
              >
              {{
                item.value && item.value.toString().trim()
                  ? item.value.toString().trim() || "-"
                  : "-"
              }}
            </ng-template>
          </li>
        </ul>
      </div>
    </div>
  </div>
</div>
<div class="modal-footer bg-light">
  <button
    type="button"
    class="btn btn-bg-outline"
    (click)="activeModal.close()"
  >
    Chiudi
  </button>
</div>
